import { useQuery } from "@tanstack/react-query";
import { UserProfilePermissionsModel } from "../../types/UserProfile";
import { axiosCoreInstance } from "src/config/axios";
import useAuth from "src/hooks/useAuth";

export const RQ_USER_PROFILE_PERMISSIONS_KEY = "USER_PROFILE_PERMISSIONS_KEY";

export type UserProfilePermissionsResponse = UserProfilePermissionsModel;

export const useProfileUserPermissions = (companyId?: string) => {
    const { userState } = useAuth();
    const currentCompanyId = companyId || userState?.company?.id;

    return useQuery({
        queryKey: [RQ_USER_PROFILE_PERMISSIONS_KEY, currentCompanyId],
        queryFn: async (): Promise<UserProfilePermissionsModel | null> => {
            if (currentCompanyId) {
                const resp = await axiosCoreInstance.get(
                    `api/user/permissions/` + currentCompanyId
                );

                return resp?.data || null;
            }
            return null;
        },
        enabled: false,
    });
};
